export default __webpack_public_path__ + "static/maxapps-designer-8977f0a351f85c25388a7d4e1fc790b8.png";